module.exports = __webpack_public_path__ + "img/xtnl-001.0386f116.jpg";